import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Text } from '@chakra-ui/react';

import { CustomHeading } from 'shared-components';

import QuestionPage from '../../../templates/question';
import Checkbox from '../../../molecules/checkboxQuestion';
import { Q } from '../../../../store/student/types';
import { useCustomNavigate } from '../../../../hooks/useCustomNavigate';
import { saveConsents } from '../../../../store/student/actions';
import { Pages } from '../../../../store/student/consents/types';

export interface IDispatchProps {
  onNext: (config: any) => void;
  onBackToTaskList: () => void;
}

export interface IProps {
  sectionTitle: string;
  currentStep: number;
  steps: number;
  consent?: boolean;
  config: any;
}

type Props = IProps & IDispatchProps;

function ConsentsQPage2(props: Props) {
  const [consent, setConsent] = useState(props.consent || false);

  const { navigateToStudentDashboard } = useCustomNavigate();
  const onBackToTaskList = () => navigateToStudentDashboard();

  const dispatch = useDispatch();
  const onNext = (config: any) => dispatch(saveConsents(Pages.PAGE2, config));

  useEffect(() => {
    setConsent(props.consent || false);
  }, [props.consent, setConsent]);

  return (
    <QuestionPage
      complete={consent}
      currentStep={props.currentStep}
      steps={props.steps}
      onNext={() => onNext(props.config)}
      onBackToTaskList={onBackToTaskList}
      section={props.sectionTitle}
    >
      <CustomHeading level={'h2'}>{props.config.Page2.heading}</CustomHeading>

      <Text
        fontSize={'lg'}
        dangerouslySetInnerHTML={{
          __html: props.config.Page2.blurb,
        }}
      />

      <Checkbox
        key={Q.CONSENTS_2}
        id={Q.CONSENTS_2}
        isTicked={consent}
        checkboxLabel={'I Agree'}
        onChange={(_key: string, isTicked: boolean) => setConsent(isTicked)}
      />
    </QuestionPage>
  );
}

export default ConsentsQPage2;
